import React from 'react';
import { always } from 'ramda';
import { FormattedMessage } from 'react-intl';

import { renderWhenTrue } from '@utils/rendering';
import { MainAnimateContainer } from '@components/mainAnimateContainer';

import { Container } from './noResults.styles';

export const NO_RESULTS_TEST_ID = 'no-results-test-id';

export interface NoResultsProps {
  isVisible: boolean;
}

export const NoResults = ({ isVisible }: NoResultsProps) =>
  renderWhenTrue(
    always(
      <MainAnimateContainer>
        <Container data-testid={NO_RESULTS_TEST_ID}>
          <FormattedMessage
            id="noResults.information"
            defaultMessage="We're sorry, but we couldn't find any results. Please try again."
          />
        </Container>
      </MainAnimateContainer>
    )
  )(isVisible);
